import Vue from 'vue'
import Router from 'vue-router'

import { config } from '@/config'

import PublicLayout from '@/layouts/PublicLayout'
import AppLayout from '@/layouts/AppLayout'

import HomeApp from '@/views/app/HomeApp.vue'
import NewOrder from '@/views/app/NewOrder'
import MyOrders from '@/views/app/MyOrders'
import ERC20TokenPage from '@/views/app/ERC20TokenPage'
import Marketplace from '@/views/app/Marketplace'
import OrdersByTokenPair from '@/views/app/OrdersByTokenPair'
import TradeHistory from '@/views/app/TradeHistory'
import OrderDetails from '@/views/app/OrderDetails'
import InstantBuy from '@/views/app/InstantBuy'
import Login from '@/views/public/Login.vue'
import Help from '@/views/public/Help.vue'
import Logout from '@/views/app/Logout.vue'

Vue.use(Router)

const router = new Router({
	routes: [

		{
			path: '/',
			name: '',
			component: PublicLayout,

			children: [
				{
					path: '',
					name: 'PublicHome',
					component: Login
				},
				{
					path: 'login',
					name: 'Login',
					component: Login
				},
        {
          path: 'help',
          name: 'HelpPublic',
          component: Help
        },
			]

		},

		{
			path: '/app',
			name: '',
			component: AppLayout,
			children: [

				{
					path: 'home',
					name: 'AppHome',
					component: HomeApp
				},

        {
          path: 'erc20token/:tokenAddress',
          name: 'ERC20TokenPage',
          component: ERC20TokenPage
        },

        {
          path: 'marketplace',
          name: 'Marketplace',
          component: Marketplace
        },

				{
          path: 'new-order',
          name: 'NewOrder',
          component: NewOrder
        },

        {
          path: 'new-order/maker/:makerAssetAddress',
          name: 'NewOrderByMaker',
          component: NewOrder
        },

        {
          path: 'new-order/taker/:takerAssetAddress',
          name: 'NewOrderByTaker',
          component: NewOrder
        },

        {
          path: 'my-orders/:orderType',
          name: 'MyOrders',
          component: MyOrders
        },

        {
          path: 'my-orders/:orderType',
          name: 'OrdersForMe',
          component: MyOrders
        },

        {
          path: 'trade-history',
          name: 'TradeHistory',
          component: TradeHistory
        },

        {
          path: 'orders/maker-taker',
          name: 'OrdersByTokenPairDefault',
          component: OrdersByTokenPair
        },

        {
          path: 'orders/maker-taker/:makerAssetSymbol/:makerAssetAddress/:takerAssetSymbol/:takerAssetAddress',
          name: 'OrdersByTokenPair',
          component: OrdersByTokenPair
        },

        {
          path: 'order/:orderHash',
          name: 'OrderDetails',
          component: OrderDetails
        },

        {
          path: 'buy/:tokenType/:tokenAddress',
          name: 'InstantBuy',
          component: InstantBuy
        },

				{
					path: 'logout',
					name: 'Logout',
					component: Logout
				},

        {
          path: 'help',
          name: 'HelpApp',
          component: Help
        },

			]
		}
	]
})


router.beforeEach((to, from, next) => {
	if (to.path.includes('/app/')) {
		if (!localStorage.getItem(config.localStorageKey.login)) {
			// console.log('no jwtToken, redirecting to login')
			router.push({ name: 'Login', query: { redirect: to.path }})
		}
	}
	next()
})

export default router
